import './main.css'
import Vue from 'vue'
import Vuex from 'vuex'
import './data/store'
import App from './App.vue'
import router from './router'
import store from './store'
import Oruga from '@oruga-ui/oruga'
import VueScrollTo from 'vue-scrollto'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import '@/plugins/fontawesome'

Vue.config.productionTip = false
Vue.use(VueScrollTo)
Vue.use(Vuex)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(Oruga, {
  iconComponent: 'font-awesome-icon',
  iconPack: 'fas',
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
